import { URLS } from "../config/urls"
import "../styles/components/VacationPackagesList.scss"

const PackageMod = ({ item }) => {

    let background = {
      background: `url(${URLS.UPLOADS_URL}${item.image}) no-repeat center center`,
      backgroundSize: "cover"
    }
  
    let price = <p>
      <em>from USD</em> <strong>{item.minPriceSolo}</strong>
    </p>
  
    let price2 = ""
  
    if (
      item.minPriceCouple &&
      item.minPriceCouple !== item.minPriceSolo &&
      item.minPriceCouple / 2 !== item.minPriceSolo
    ) {
      price = <p className="price">
        <del>
          <em>One guest</em>
          <em>from USD</em>
        </del>{" "}
        <strong>{item.minPriceSolo}</strong>
      </p>
  
      price2 = <p className="price">
        <del>
          <em>Two guests</em>
          <em>from USD</em>
        </del>{" "}
        <strong>{item.minPriceCouple}</strong>
      </p>
    }
  
    return (
      <div key={item.id} className="package" style={background}>
        <a href={"/vacation-packages/" + item.slug}>
          <h2>{item.name}</h2>
          <p>{item.description}</p>
          <hr />
          {price}
          {price2}
        </a>
      </div>
    )
  }

  export default PackageMod